import VueI18n from 'vue-i18n';

export class I18n extends VueI18n {}

export function createI18n(locale: string = 'en-US'): I18n {
  return new I18n({
    locale,
    fallbackLocale: locale
  });
}
